import '../../src/App.css';
import '../../src/Css/bootstrap.min.css';

import Ticket from "./pages/Ticket";
import HomePage from './pages/index';
import Commands from './pages/Commands';
import { useDispatch } from 'react-redux';
import Complaint from "./pages/Complaint";
import Loader from 'react-loader-spinner';
import Invoice from "../Sale/pages/Invoice";
import { useState, useEffect, Fragment } from 'react';
import Menu from '../Components/Header/Menu';
import PrintViewer from '../Pages/PrintViewer';
import PopupMenu from './Components/PopupMenu';
import EventsHistory from "./pages/EventsHistory";
import ModalDialog from './Components/ModalDialog';
import SearchCustomer from './pages/SearchCustomer';
import MenuWide from '../Components/Header/MenuWide';
import AddEditCustomer from './pages/AddEditCustomer';
import MyCommands from '../Services/pages/MyCommands';
import SearchPreCustomer from './pages/SearchPreCustomer';
import ModalEnlargeImage from "./Common/ModalEnlargeImage";
import AddEditPreCustomer from './pages/AddEditPreCustomer';
import ModalCustomerStatus from "./pages/ModalCustomerStatus";
import AddEditSaleCampaign from './pages/AddEditSaleCampaign';
import AddEditCustomerService from './pages/AddEditCustomerService';
import ModalPreCustomerStatus from "./pages/ModalPreCustomerStatus";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { getActiveSubsystems,  useIsMobileApp } from '../store/api/CommonFunctions';
import SearchCommands from '../Pages/SearchCommands';
import { getAppConfig } from '../store/api/SystemSettingsAPI';
import HappyCallSettings from './pages/HappyCallSettings';
import HappyCallServiceList from './pages/HappyCallServiceList';
import Happycall from './pages/Happycall';
import UserDashboard from '../Pages/UserDashboard';
import SearchComplaints from './pages/SearchComplaints';
import ModalSMSTemplates from '../Components/Modals/ModalSMSTemplates';
import SearchSentSMS from '../Pages/SearchSentSMS';
import SearchReceivedSMS from '../Pages/SearchReceivedSMS';
import CallHistory from './pages/CallHistory';
import HappycallGrades from './pages/HappycallGrades';
import CustomersHappycallGrades from './pages/CustomersHappycallGrades';
import HappycallVarianceList from './pages/HappycallVarianceList';
import CallDashboard from './pages/CallDashboard';


const requireAuth = (setUser) => {
  const token = localStorage.getItem('token');
  if (token !== null && token) {
    setUser(token);
  } else {
    setUser(null);
  }
}


function App(props) {
  const isMobile = useIsMobileApp();
  const { setQAList, setModalAboutUs } = props;
  const [pending, setPending] = useState(true);
  const [currentUser, setUser] = useState(null);
  const [forgetPassword, setForgetPassword] = useState(false);
  const [menuWidth, setMenuWidth] = useState(false);
  const dispatch = useDispatch();
  const userInfo = JSON.parse(localStorage.getItem("UserInfo"));
  useEffect(() => {
    requireAuth(setUser);
    setPending(false);
    dispatch(getActiveSubsystems());
    dispatch(getAppConfig());
    document.getElementById("CompanyName")?.setAttribute("systemname", "سیستم مشتریان");
  }, []);
  return (
    <div className="App">
      <Router>
        <ModalDialog />
        <ModalEnlargeImage />
        {currentUser &&
          <Fragment>
            <PopupMenu />
            <div style={{ position: "relative", height: "max-content", display: "flex", paddingRight:"12px", paddingLeft:"12px" }}>
              {isMobile ? <Menu menuName="CRM" />:
                <Fragment>
                  <span style={{ fontSize: "30px", cursor: "pointer", position: "relative" }} onClick={() => { setMenuWidth("250px") }}>&#9776;</span>
                  <MenuWide menuWidth={menuWidth} setMenuWidth={setMenuWidth} currentUser={currentUser} setModalAboutUs={setModalAboutUs} menuName="CRM" setQAList={setQAList} />
                </Fragment>}
            </div>
            <Switch>
              <Route path="/CRM/Complaint/:compID/:serviceType/:serviceID"><Complaint /></Route>
              <Route path="/CRM/SearchComplaints"><SearchComplaints /></Route>
              <Route path="/CRM/SearchCustomer"><SearchCustomer /></Route>
              <Route path="/CRM/SearchPreCustomer"><SearchPreCustomer /></Route>
              <Route path="/CRM/AddEditCustomer/:id"><AddEditCustomer /></Route>
              <Route path="/CRM/EventsHistory"><EventsHistory /></Route>
              <Route path="/CRM/AddEditSaleCampaign/:id"><AddEditSaleCampaign /></Route>
              <Route path="/CRM/ModalCustomerStatus"><ModalCustomerStatus /></Route>
              <Route path="/CRM/AddEditPreCustomer/:id"><AddEditPreCustomer /></Route>
              <Route path="/CRM/ModalPreCustomerStatus"><ModalPreCustomerStatus /></Route>
              <Route path="/CRM/Commands/:commandID/:attachmentID/:attachmentType"><Commands /></Route>
              <Route path="/CRM/AddEditCustomerService/:serviceID/:serviceType/:customerID"><AddEditCustomerService /></Route>
              <Route path="/Services/MyCommands"><MyCommands /></Route>
              <Route path="/PrintViewer/:reportName/:designMode"><PrintViewer /></Route>
              <Route path="/Sale/Invoice/:invoiceType/:invoiceID/:isFormal"><Invoice /></Route>
              <Route path="/SearchCommands"><SearchCommands /></Route>
              <Route path="/CRM/Ticket"><Ticket /></Route>
              <Route path="/CRM/HappyCallSettings"><HappyCallSettings /></Route>
              <Route path="/CRM/HappyCallServiceList"><HappyCallServiceList /></Route>
              <Route path="/CRM/HappyCall/:serviceType/:serviceID"><Happycall /></Route>
              <Route path="/CRM/CallHistory"><CallHistory /></Route>
              <Route path="/UserDashboard"><UserDashboard /></Route>
              <Route path="/SMSTemplates"> <ModalSMSTemplates /></Route>
              <Route path="/SearchSentSMS"><SearchSentSMS /></Route>
              <Route path="/SearchReceivedSMS"><SearchReceivedSMS /></Route>
              <Route path="/CRM/HappycallGrades"><HappycallGrades/></Route>
              <Route path="/CRM/CustomersHappycallGrades"><CustomersHappycallGrades/></Route>
              <Route path="/CRM/HappycallVarianceList"><HappycallVarianceList/></Route>
              <Route path="/CRM/CallDashboard"><CallDashboard/></Route>
              <Route path={userInfo?.HomePage === "CRM" ? "/" : "/CRM"}><HomePage /></Route>

            </Switch>
          </Fragment>
        }
        {pending &&
          <Loader type="BallTriangle"
            color="#bb1370"
            height={50}
            width={50} />}

      </Router>
    </div>
  );
}

export default App;
